// extracted by mini-css-extract-plugin
export default {"Curatorship":"Curatorship_Curatorship__hc9e4"};